import React from 'react'
import PCard from './PCard'
import PData from './PData'
import './Prices.css'


const Prices = () => {
  return (
   
        <div className="price-section">
            <h2 className="fade-in" > <span> OUR</span> Prices</h2 >
                <div className="price-info">
                   
                            {PData.map((val,ind)=>{
                                return(
                                    <PCard  
                                    title={val.title}
                                    description={val.description}
                                    design1={val.design1}
                                    design2={val.design2}
                                    design3={val.design3} 
                                    design4={val.design4} 
                                    design5={val.design5} 
                                    design6={val.design6} 
                                    design7={val.design7} 
                                    design8={val.design8} 
                                    />
                                );
                            })}
                            
                

                   
                    

                </div>
                <ul className='price-policy'>
                                <li>All prices are in $AUD, include GST, are current from September 1st 2021.
<li>Prices are subject to change without notice.</li>
<li>We prefer to quote on services prior to commitment.</li>
<li>We accepts Visa, Mastercard, EFTPOS and Cash. Cheques are not accepted.
24 hour cancellation notice required.</li>
                                </li>
                            </ul>
        </div>
       
   
  )
}

export default Prices